// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/erp开发/erp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/erp开发/erp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import BarChartOutlined from 'D:/erp开发/erp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
export default { SmileOutlined, CrownOutlined, BarChartOutlined };
